import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, shareReplay, tap, toArray } from 'rxjs/operators';
import { AVATAR_SERVICE, AUTH_SERVICE, ADMIN_SERVICE, ROLEPLAY_SERVICE } from './service-url'
import { customize } from '../model/interaction.model';
import { PlatformRegionService } from './shared/platform-region.service';
import { getRouteDecision } from '../constants/api-routing';

@Injectable({
  providedIn: 'root'
})
export class TraineeListService {
  sessionTimeout$ = new Subject();
  private readonly customizeDetailsCache = new Map<string, Observable<any>>();

  constructor(private http: HttpClient, private PlatformRegionService: PlatformRegionService) { }
  

  public getTraineeList(): Observable<any> {
    return this.http.get(AUTH_SERVICE.getTraineeListSummary);
  }

  public getAssignedTraineeList(request): Observable<any> {
    return this.http.post(ROLEPLAY_SERVICE.roleplayAssignedTraineeList , request);
  }

  public getScenarioToTrainer(business_unit_code): Observable<any> {

    return this.http.get(ROLEPLAY_SERVICE.roleplayListToTrainer+ '' +business_unit_code)
  }

  public getScenarioToTrainee(userId: number, business_unit_code): Observable<any> {
    if (userId) {
      return this.http.get(ROLEPLAY_SERVICE.roleplayListToTrainee + '/' + userId + '/' +business_unit_code);
    }
    else {
      return null;
    }
  }
  public getScenarioToTrainerbyId(ScenarioId:number): Observable<any> {
    return this.http.get(ROLEPLAY_SERVICE.roleplayListToTrainer + ScenarioId);
  }
  public getDashboardTraineeSummary(value: string): Observable<any> {
    return this.http.get(ADMIN_SERVICE.getDashboardTraineeSummary + '/?filter_value=' + value);
  }

  public getDashboardDailyscore(): Observable<any> {
    return this.http.get(ADMIN_SERVICE.getDashboardDailyscore + '/');
  }
  public getDashboardRoleplays(time:string): Observable<any> {
    return this.http.get(ADMIN_SERVICE.getDashboardRoleplays + '/?time_frame=' + time);
  }
  public getDashboardRoleplaysByDate(value: string):Observable<any>{
    return this.http.get(ADMIN_SERVICE.getDashboardDailyscoreByDate + '/?time_frame=' + value);
  }
  public getDashboardAvatarUSage():Observable<any>{
    return this.http.get(ADMIN_SERVICE.getDashboardAvatarcount +'/');
  }
  public getDashboardAvatarUSageData(value: string, chat_type?: string, chat_topic?: string): Observable<any> {
    let url = `${ADMIN_SERVICE.getDashboardAvatarbyDate}/?time_frame=${value}`;
    if (chat_type) {
        url += `&chat_type=${chat_type}`;
    }
    if (chat_topic) {
        url += `&chat_topic=${chat_topic}`;
    }
    return this.http.get(url);
}


  public deleteAssignScenario(scenarioId: number): Observable<any> {
    return this.http.delete(ROLEPLAY_SERVICE.deleteScenario + '/' + scenarioId);
  }
  public getCustomizeDetails(): Observable<any> {
    const bu = this.PlatformRegionService.selected_platform_code;
    const region_name = this.PlatformRegionService.selected_region_code;
    const key = `${bu}|${region_name}`;
    const cached = this.customizeDetailsCache.get(key);
    if (cached) {
      return cached;
    }
    const request$ = this.http.get(ADMIN_SERVICE.getCustomizeDetailsByProductCode + '/'+ bu + `?region_name=${region_name}`).pipe(
      catchError(err => {
        this.customizeDetailsCache.delete(key);
        return throwError(() => err);
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
    this.customizeDetailsCache.set(key, request$);
    return request$;
  }

  /** Must be called whenever the LLM configuration changes server-side. */
  public clearCustomizeDetailsCache(): void {
    this.customizeDetailsCache.clear();
  }

  public createCustomizeDetails(request, id): Observable<any> {
    if (request) {
      // Admin microservice expects LLMConfigUpdateV1 { fields: {...} }; monolith expects the flat object.
      const isMicro = getRouteDecision('admin').backend === 'microservice';
      const body = isMicro ? { fields: request } : request;
      return this.http.put(`${ADMIN_SERVICE.createCustomizeDetails}/${id}`, body).pipe(
        tap(() => this.clearCustomizeDetailsCache())
      );
    }
    else {
      return null;
    }
  }
  public getTraineeSummaryById(wwid: number): Observable<any> {
    if(wwid) {
      return this.http.get(AUTH_SERVICE.getTraineeSummaryById + '/' + wwid);
    } else {
      return null;
    }
  }

  public getavatarTimeAllocation(wwid: number): Observable<any> {
    if(wwid) {
      return this.http.get(AVATAR_SERVICE.avatar_time_allocation_by_user_id + '/' + wwid);
    } else {
      return null;
    }
  }

  public getTraineeRolePlaySummaryById(wwid: number): Observable<any> {
    if(wwid) {
      return this.http.get(ROLEPLAY_SERVICE.getTraineeRoleplaySummaryById + '/' + wwid);
    } else {
      return null;
    }
  }

  public updateAvatarStatus(ReqData): Observable<any> {
    return this.http.put<any>(AVATAR_SERVICE.update_avtar_enabled, ReqData);
  }  

  public updateAvatarAllocation(Id, ReqData): Observable<any> {
    return this.http.put<any>(`${AVATAR_SERVICE.update_avatar_time_allocation}/${Id}`, ReqData);
  }  

  public createAvatarAllocation (request) {
        return this.http.post(AVATAR_SERVICE.create_avatar_time_allocation, request);
}

}